export default __webpack_public_path__ + "static/media/schoolAdImg.25f0b11b.jpg";